// src/components/BottomNav.jsx
import { useLocation, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { BookOpen, CalendarDays, User } from "lucide-react";

const tabs = [
  { path: "/mis-clases", icon: BookOpen, label: "Mis Clases" },
  { path: "/horario", icon: CalendarDays, label: "Horario" },
  { path: "/perfil", icon: User, label: "Perfil" },
];

function BottomNav() {
  const location = useLocation();
  const navigate = useNavigate();

  const activeIndex = tabs.findIndex((tab) => tab.path === location.pathname);

  // Al tocar un tab: sube suave (volver-arriba). Si ya estás en esa ruta NO navega
  // (no recarga nada), solo sube. Según la página el scroll lo lleva el documento
  // o el contenedor .app-scroll, así que subimos ambos por seguridad.
  const irATab = (path) => {
    const opts = { top: 0, behavior: 'smooth' };
    try { window.scrollTo(opts); } catch { /* noop */ }
    document.scrollingElement?.scrollTo?.(opts);
    document.querySelector('.app-scroll')?.scrollTo?.(opts);
    if (path !== location.pathname) navigate(path);
  };

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-base-100 border-t border-base-300 px-4 py-2 z-50" style={{ paddingBottom: 'max(0.5rem, env(safe-area-inset-bottom))' }}>
      <div className="relative flex items-stretch max-w-md mx-auto">
        {/* Pill indicator animado: centrado horizontalmente sobre cada tab */}
        {activeIndex !== -1 && (
          <motion.div
            className="absolute top-1 bottom-1 bg-primary/10 rounded-2xl -z-10"
            initial={false}
            animate={{
              left: `${(activeIndex * 100) / tabs.length}%`,
            }}
            transition={{
              type: "spring",
              stiffness: 350,
              damping: 30,
            }}
            style={{
              width: `${100 / tabs.length}%`,
            }}
          />
        )}

        {tabs.map((tab) => {
          const isActive = location.pathname === tab.path;
          const Icon = tab.icon;

          return (
            <button
              key={tab.path}
              onClick={() => irATab(tab.path)}
              className="flex-1 flex flex-col items-center justify-center py-2 relative z-10"
            >
              <motion.div
                animate={{
                  scale: isActive ? 1.1 : 1,
                }}
                transition={{ type: "spring", stiffness: 400, damping: 20 }}
              >
                <Icon
                  size={24}
                  className={isActive ? "text-primary" : "text-base-content/50"}
                  strokeWidth={isActive ? 2.5 : 2}
                />
              </motion.div>
              <motion.span
                className={`text-xs mt-1 font-medium ${
                  isActive ? "text-primary" : "text-base-content/50"
                }`}
                animate={{
                  opacity: isActive ? 1 : 0.7,
                }}
              >
                {tab.label}
              </motion.span>
            </button>
          );
        })}
      </div>
    </nav>
  );
}

export default BottomNav;